// local repaint tick, no REST: every tick while a job is building (timer), else every AGE_REPAINT_TICKS (age columns)
export const BUILD_OVERVIEW_TICK_MS = 1000;
export const AGE_REPAINT_TICKS = 30;

// provider neutral results, see BuildStatusDto.LastResult
export const BUILD_RESULT = {
    SUCCESS: 'success',
    FAILED: 'failed',
    UNSTABLE: 'unstable',
    ABORTED: 'aborted',
    BUILDING: 'building',
};

// results shown in the Failed tab
export const FAILED_RESULTS = [BUILD_RESULT.FAILED, BUILD_RESULT.UNSTABLE];

export const BUILD_TAB = { RECENT: 'recent', ALL: 'all', FAILED: 'failed' };

// Recent tab: built within this window, Restart jobs excluded
export const RECENT_MS = 48 * 60 * 60 * 1000;

// changed row flashes this long, matches the CSS animation (3 x 1s)
export const FLASH_MS = 3 * 1000;

// group tabs are keyed 'group:KD8', 'group:Treetek' etc, prefix avoids clashes with the fixed tabs
export const GROUP_TAB_PREFIX = 'group:';

// platforms, matched on the part before the first dot (case-insensitive, exact so Bme6 is not Bme)
export const PLATFORM_GROUPS = ['KD8', 'Bme6', 'Bme', 'Treetek'];

// everything else, e.g. Jerny.*, kdesk.*
export const GROUP_OTHER = 'Other';

// tab order after All / Failed
export const GROUP_TABS = [...PLATFORM_GROUPS, GROUP_OTHER];

// env buttons under the filter, matched on the part after the last dot (case-insensitive)
export const KNOWN_ENVS = ['DEV', 'TEST', 'ACC', 'PROD', 'RESTART'];

// every trail not in KNOWN_ENVS, e.g. ODROID, PI4, K10
export const ENV_OTHER = 'OTHER';

// no env filter
export const ENV_ALL = 'ALL';

export const ENV_FILTERS = [ENV_ALL, ...KNOWN_ENVS, ENV_OTHER];

// matrix columns, matched on the job suffix after the last dot (case-insensitive)
export const ENV_COLUMNS = ['DEV', 'TEST', 'ACC', 'PROD'];

// JxDataGrid column id of the service column, sorting on it = default sort (building, failed, name)
export const SERVICE_COLUMN = 'service';

// columns with a hammer: double click starts the job, admin only
export const TRIGGER_COLUMNS = ['TEST', 'ACC', 'PROD'];

// legacy job suffixes mapped onto a column — LBA02 = old naming of ACC deploys (2024 crypto services)
export const ENV_ALIASES = { LBA02: 'ACC' };

// suffixes of retired build agents, their jobs are hidden
export const IGNORED_ENVS = ['LBA01'];

// chip without group filter, always last
export const GROUP_ALL = 'All';
export const DEFAULT_GROUP = 'KD8';

// selected group chip remembered per browser, column sort is persisted by JxDataGrid (gridId)
export const BUILD_OVERVIEW_STORAGE_KEY = 'jerny.buildOverview.v2';
export const BUILD_OVERVIEW_DEFAULTS = { group: DEFAULT_GROUP };
export const BUILD_GRID_ID = 'buildOverview';

export const BUILD_OVERVIEW_TEXT = {
    title: 'Builds',
    loading: 'Loading builds…',
    error: 'Could not fetch builds.',
    retry: 'Click here to retry',
    tabRecent: 'Recent',
    tabAll: 'All',
    tabFailed: 'Failed',
    filter: 'Filter jobs…',
    notBuilt: 'not built',
};
